import { Modal, Input, Button, message } from "antd"
import { localStorageKey } from '@/config/config'
import config from '@/config/env'

export const successAlert = (message, callback?) => {
  Modal.success({
    title: '提示',
    content: message,
    onOk() {
      if(typeof callback === 'function') {
        callback()
      }
    }
  })
}

export const alert = (title, message, callback?) => {
  Modal.info({
    title,
    content: (
      <div>
        <p>{message}</p>
      </div>
    ),
    onOk() {
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
  });
}

export const confirm = (message, title='温馨提示') => {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title,
      content: (
        <div>
          <p>{message}</p>
        </div>
      ),
      okText: "是",
      cancelText: "否",
      onOk() {
        resolve(true)
      },
      onCancel() {
        resolve(false)
      },
    });
  })
}

export const getLocalstorage = (key) => {
  const val = window.localStorage.getItem(localStorageKey + key)
  if(!val) {
    return null
  }
  return JSON.parse(val).value
}

export const setLocalstorage = (key, value) => {
  window.localStorage.setItem(localStorageKey + key, JSON.stringify({
    value
  }))
}

// 复制
export const copyTextToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    message.success('内容已复制到剪贴板')
  } catch (err) {
    console.error('复制到剪贴板失败', err);
  }
}


export const sleep = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, time)
  })
}

export const isEmpty = (val) => {
  return ['', null, undefined].includes(val)
}

// 千分位转换
export const numFormat =(num) => {
  const res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
       return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
          return `${$1},`;
        });
  })
  return res;
}
